import { render } from "./NewMembersearch.vue?vue&type=template&id=2136cc45"
import script from "./NewMembersearch.vue?vue&type=script&lang=js"
export * from "./NewMembersearch.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__